/**
 * @file
 *
 * The global error boundary fallback component
 */
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

export function GlobalErrorFallback({ resetErrorBoundary }) {
  useEffect(() => {
    return resetErrorBoundary;
  }, [resetErrorBoundary]);

  return (
    <Redirect
      to={{
        pathname: '/error',
        state: {
          title: 'Something unexpected happened',
          body: 'An unexpected error occurred. Please try again, or contact support if the problem persists.',
          isFatal: true,
        },
      }}
    />
  );
}
